import React from "react";
import withRouter from "utility/with-router";
import SidebarData from "./SidebarData.ts";
import Sidebar from "../../../components/layout/components/sidebar";
import useWebOriEnabled from "apps/user/learner/hooks/use-web-ori-enabled";
import { OriAvatar } from "components/ori";

// Looser crop than the chat header/empty-state orb — the nav icon reads better
// with a little breathing room next to the other sidebar glyphs.
const OriNavIcon = ({ width }) => <OriAvatar size={width} cropScale={2.0} />;

const ORI_NAV_ITEM = {
  title: "Ori",
  path: "/user/chat",
  imgName: OriNavIcon,
};

const SNavbar = () => {
  const { enabled: showOriWeb } = useWebOriEnabled();

  const sidebarData = showOriWeb
    ? [...SidebarData.slice(0, 2), ORI_NAV_ITEM, ...SidebarData.slice(2)]
    : SidebarData;

  return <Sidebar sidebarData={sidebarData} />;
};

export default withRouter(SNavbar);
